import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Animate from '../../wui-animate/src';
import Icon from '../../wui-icon/src';
import ProgressBar from '../../wui-progress/src';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import i18n from './i18n';
import { getComponentLocale } from '../../wui-locale/src/tool';
import { WebUI } from "../../wui-core/src/index.js"; //import { UploadListProps } from './interface';
// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL

var previewFile = function previewFile(file, callback) {
  var reader = new FileReader();

  reader.onloadend = function () {
    return callback(reader.result);
  };

  reader.readAsDataURL(file);
};

var propTypes = {
  listType: PropTypes.oneOf(['text', 'picture', 'picture-card']),
  onPreview: PropTypes.func,
  onRemove: PropTypes.func,
  items: PropTypes.array,
  progressAttr: PropTypes.object,
  clsPrefix: PropTypes.string
};
var defaultProps = {
  listType: 'text',
  // or picture
  progressAttr: {
    strokeWidth: 3,
    showInfo: false
  },
  clsPrefix: 'u-upload',
  showRemoveIcon: false,
  showDownloadIcon: false,
  showPreviewIcon: true
};
var UploadList = (_dec = WebUI({
  name: "upload",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(UploadList, _Component);

  var _super = _createSuper(UploadList);

  function UploadList() {
    var _this;

    _classCallCheck(this, UploadList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (file) {
      var onRemove = _this.props.onRemove;

      if (onRemove) {
        onRemove(file);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDownLoad", function (file) {
      var onDownload = _this.props.onDownload;
      onDownload(file);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePreview", function (file, e) {
      var onPreview = _this.props.onPreview;

      if (!onPreview) {
        return;
      }

      e.preventDefault();
      return onPreview(file);
    });

    return _this;
  }

  _createClass(UploadList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
        return;
      }

      (this.props.items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || //!(window as any).FileReader || !(window as any).File ||
        !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */


        file.thumbUrl = '';
        /*eslint-enable */

        previewFile(file.originFileObj, function (previewDataUrl) {
          /*eslint-disable */
          file.thumbUrl = previewDataUrl;
          /*eslint-enable */

          _this2.forceUpdate();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _classNames2;

      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          listType = _this$props.listType,
          showRemoveIcon = _this$props.showRemoveIcon,
          showDownloadIcon = _this$props.showDownloadIcon,
          showPreviewIcon = _this$props.showPreviewIcon;
      var local = getComponentLocale(this.props, this.context, 'Upload', function () {
        return i18n;
      });
      var list = items.map(function (file) {
        var _classNames;

        var progress;
        var icon = /*#__PURE__*/React.createElement(Icon, {
          type: "uf-link"
        });

        if (listType === 'picture' || listType === 'picture-card') {
          if (file.status === 'uploading' || !file.thumbUrl && !file.url) {
            if (listType === 'picture-card') {
              icon = /*#__PURE__*/React.createElement("div", {
                className: "".concat(clsPrefix, "-list-item-uploading-text")
              }, local['fileLoading']);
            } else {
              icon = /*#__PURE__*/React.createElement(Icon, {
                className: "".concat(clsPrefix, "-list-item-thumbnail"),
                type: "picture"
              });
            }
          } else {
            console.log('----file----', file);
            icon = /*#__PURE__*/React.createElement("a", {
              className: "".concat(clsPrefix, "-list-item-thumbnail"),
              onClick: function onClick(e) {
                return _this3.handlePreview(file, e);
              },
              href: file.url || file.thumbUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, /*#__PURE__*/React.createElement("img", {
              src: file.thumbUrl || file.url,
              alt: file.name
            }));
          }
        }

        if (file.status === 'uploading') {
          progress = /*#__PURE__*/React.createElement(ProgressBar, {
            colors: "success",
            size: "sm",
            now: file.percent
          });
        }

        var infoUploadingClass = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-list-item"), true), _defineProperty(_classNames, "".concat(clsPrefix, "-list-item-").concat(file.status), true), _classNames));
        var preview = file.url ? /*#__PURE__*/React.createElement("a", {
          href: file.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "".concat(clsPrefix, "-list-item-name"),
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          }
        }, file.name) : /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-list-item-name"),
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          }
        }, file.name);
        var style = file.url || file.thumbUrl ? undefined : {
          pointerEvents: 'none',
          opacity: 0.5
        };
        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
          href: file.url || file.thumbUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          style: style,
          onClick: function onClick(e) {
            return _this3.handlePreview(file, e);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "uf-eye-o"
        })) : null;
        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(Icon, {
          type: "uf-del",
          title: _this3.props.removeText || local['remove'],
          onClick: function onClick() {
            return _this3.handleClose(file);
          }
        }) : null;
        var downloadIcon = showDownloadIcon ? /*#__PURE__*/React.createElement(Icon, {
          type: "uf-download",
          title: _this3.props.downloadText || local['down'],
          onClick: function onClick() {
            return _this3.handleDownLoad(file);
          }
        }) : null;
        var removeIconClose = !showRemoveIcon ? /*#__PURE__*/React.createElement(Icon, {
          type: "uf-close",
          title: _this3.props.removeText || local['remove'],
          onClick: function onClick() {
            return _this3.handleClose(file);
          }
        }) : null;
        var actions = listType === 'picture-card' && file.status !== 'uploading' ? /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-list-item-actions")
        }, previewIcon, removeIcon) : /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-list-item-actions")
        }, removeIcon, file.status === 'done' && downloadIcon, removeIconClose);
        return /*#__PURE__*/React.createElement("div", {
          className: infoUploadingClass,
          key: file.uid
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-list-item-info")
        }, icon, preview, actions), progress);
      });
      var listClassNames = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(clsPrefix, "-list"), true), _defineProperty(_classNames2, "".concat(clsPrefix, "-list-").concat(listType), true), _classNames2));
      return /*#__PURE__*/React.createElement(Animate, {
        transitionName: "".concat(clsPrefix, "-margin-top"),
        component: "div",
        className: listClassNames
      }, list);
    }
  }]);

  return UploadList;
}(Component)) || _class);
UploadList.propTypes = propTypes;
export default UploadList;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/uploadList.js